import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const SessionTimeoutWarning = ({ onExtend, onTimeout }) => {
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    if (countdown <= 0) {
      onTimeout();
      return;
    }
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, onTimeout]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-900">Session Timeout Warning</h2>
        </div>
        <p className="text-slate-600 mb-6">
          For your security, you will be automatically logged out in:
        </p>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-600">{countdown}</div>
            <div className="text-sm text-slate-600 mt-1">seconds</div>
          </div>
        </div>
        <button onClick={onExtend} className="w-full bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700">
          Continue Session
        </button>
        <p className="text-xs text-slate-500 text-center mt-4">
          HIPAA security requirement
        </p>
      </div>
    </div>
  );
};

export default SessionTimeoutWarning;